const ACCOUNT_EMAIL_PATTERN = /^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/

export function isValidAccountEmail(email) {
  return ACCOUNT_EMAIL_PATTERN.test(String(email || ''))
}
